import axios from 'axios/index';
import _ from 'lodash';

const API_GATEWAY = process.env.REACT_APP_API_GATEWAY

export function ApiUrl(path) {
  return `${API_GATEWAY}/${path}`;
}

export function HttpErrorMessage(error) {
  const status = error.response ? error.response.status : '';
  if (_.get(error, 'response.data.errors', null)) {
    return {
      message: error.response.data.errors,
      code: status,
    };
  } else if (_.get(error, 'response.data', null)) {
    return {
      message: error.response.data,
      code: status,
    };
  }
  return [error.message, status];
}

export function ParseGeneralResponse(success, response, options) {
  const result = { success };
  if (!_.isEmpty(options.return)) {
    result.return = options.return;
  }
  if (success) {
    const dataKeys = options.responseDataKeys || {};
    _.forEach(dataKeys, (value, key) => {
      const valueKey = _.isEmpty(value) ? 'data' : `data.${value}`;
      result[key] = _.get(response, valueKey, null);
    });
  } else {
    result.errors = HttpErrorMessage(response);
  }
  return result;
}

export function Call(method, url, data, parseCallback, options = {}, authorization) {
  const dataObj = {
    method,
    url,
    data,
  };

  return new Promise(resolve => {
    axios(dataObj)
      .then(response => {
        resolve(parseCallback(true, response, options));
      })
      .catch(async error => {
        if (error.message === 'Network Error') {
          alert('Network Error. Please check your net connection!');
        } else if (error.response && error.response.status === 400) {
          alert(error.response.data["message"]);
        } else if (error.response) {
          alert(error.response.data["message"]);
        } else {
          alert('An unexpected error occurred');
        }
        resolve(parseCallback(false, error, options));
      });
  });
}